import { writable, type Writable } from 'svelte/store';
import type { DisplayView, PlayerView } from '@banger/shared';

export const view: Writable<DisplayView | PlayerView | null> = writable(null);
/** serverNow - Date.now(), updated on every view. */
export const clockOffset: Writable<number> = writable(0);

export function applyView(v: DisplayView | PlayerView): void {
  view.set(v);
  clockOffset.set(v.serverNow - Date.now());
}
